import { Fragment, useCallback, useContext, useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { useAuth } from "../../Context/AuthContext";
import { useFlashLoaderLoader } from "../../Context/FlashScreenContext";
import { IsNumberKeyWithoutZero, isValidArray } from "../../Layout/Common/common";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { useNavigate } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
export const EbookQuickOrderLineEntry = ({ AddtoCart }) => {
  const [suggestion, setSuggestion] = useState(null);
  const [productCode, setProductCode] = useState("");
  const [errorItem, setErrorItem] = useState(null);
  const [qty, setQty] = useState(1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const suggestionListRef = useRef(null);
  const quantityInputRef = useRef(null);
  const { showLoader, hideLoader } = useFlashLoaderLoader();
  const [searchItem, setsearchItem] = useState(null);
  const [searchItemSubstuitu, setsearchItemSubstuitu] = useState(null);
  const [addSuccess, setaddSuccess] = useState(false);
  const [dataempty, setdataempty] = useState(false);
  const [addtoCardDisplay, setAddtoCardDisplay] = useState("block");
  const history = useNavigate();
  const { getStockStatus, GetPriceTableData } = useGlobalFunction();
  const [productStockStatus, setProductStockStatus] = useState(null);
  const [searchResult, setSearchResult] = useState(null);
  const { isAuthenticated, userId, companyId, setUser, setAthuLoading, emailAddress, role, eBayBlock } = useAuth();
  const codeInputRef = useRef(null);
  const [priceData, setPriceData] = useState([]);

  useEffect(() => {
    handleOnSearch("");
  }, []);

  useEffect(() => {
    if (searchResult && searchResult.PrdId) {
      if (productStockStatus?.substituteCode != "") {
        setsearchItemSubstuitu(productStockStatus);
        setsearchItem(null);
      } else {
        setsearchItem(searchResult);
        if (searchResult.OrderCode == "") {
          setdataempty(true);
        } else setdataempty(false);
        const stockStatusText = (productStockStatus?.stockStatus ?? "")
          .replace(/<[^>]*>/g, " ")
          .replace(/\s+/g, " ")
          .trim()
          .toUpperCase();
        if (
          stockStatusText === "DISCONTINUED NO LONGER AVAILABLE" ||
          stockStatusText === "TEMPORARY_UNAVAILABLE NO ETA" ||
          stockStatusText === "TEMPORARY UNAVAILABLE NO ETA"
        ) {
          setAddtoCardDisplay("none");
        } else {
          setAddtoCardDisplay("block");
        }
        setsearchItemSubstuitu(null);
        setQty(1);
        if (quantityInputRef.current) {
          quantityInputRef.current.focus();
        }
      }
    }
  }, [productStockStatus]);
  const handleCallback = useCallback((errItem) => {
    try {
      if (isValidArray(errItem)) {
        setErrorItem(errItem);
      } else {
        setErrorItem(null);
        setProductCode("");
        setSuggestion(null);
        setQty(1);
        if (codeInputRef.current) {
          codeInputRef.current.focus();
        }
      }
      setaddSuccess(true);
    } catch (error) {
      console.error("Quick Order", error);
    }
  }, []);

  const handleOnType = (e) => {
    setaddSuccess(false);
    setsearchItem(null);
    if (e.target.value || e.target.value == "") {
      setProductCode(e.target.value);
      handleOnSearch(e.target.value);
    }
  };
  const handleOnSearch = (txt) => {
    if (txt == "") setSuggestion([]);
    else {
      axiosInstance
        .post("GetStaticData/ProductCodeAutoComplete", {
          sku: txt,
        })
        .then((response) => {
          if (response.data) {
            setSuggestion(response.data);
          }
        })
        .catch((error) => console.log(error.message));
    }
  };
  const autosuggestionKeyPress = (e) => {
    if (e.key == "ArrowDown" && activeSuggestion < suggestion.length - 1) {
      //setactiveSuggestion(parseInt(activeSuggestion) + 1);
      setActiveSuggestion((prev) => {
        const nextIndex = prev < suggestion.length - 1 ? prev + 1 : 0;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "ArrowUp" && activeSuggestion > 0) {
      setActiveSuggestion((prev) => {
        const nextIndex = prev > 0 ? prev - 1 : suggestion.length - 1;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "Enter") {
      if (activeSuggestion < suggestion.length) {
        setProductCode(suggestion[0].code);
        setShowSuggestions(false);
        if (quantityInputRef.current) {
          quantityInputRef.current.focus();
        }
      }
      ProDetailsList(suggestion[0].code);
    }
  };
  const scrollToActiveSuggestion = (index) => {
    const list = suggestionListRef.current;
    if (list) {
      const item = list.children[index + 2] || list.children[index + 1] || list.children[index];

      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };
  const QuantityInc = () => {
    let currentqty = parseInt(qty + 1);
    setQty(currentqty);
    //debouncedFunction(product.prod_id, currentqty, "INC");
  };
  const QuantityDec = () => {
    if (qty > 1) {
      setQty(parseInt(qty - 1));
    }
  };
  const handleOnChange = (e) => {
    var value = IsNumberKeyWithoutZero(e.target.value);
    setaddSuccess(false);
    setQty(value);
  };
  const AddItemCart = () => {
    if (productCode && qty) {
      var data = [
        {
          sku: productCode,
          qty: parseInt(qty),
        },
      ];

      AddtoCart(data, handleCallback);
    }
  };

  const fetchStockStatus = async (productId) => {
    let res = await getStockStatus(productId ?? 0);
    if (res) setProductStockStatus(res);
  };
  const fetchPriceData = async (productId, productCode) => {
    const normalizedProductCode = String(productCode ?? "").trim();
    if (!productId || !normalizedProductCode || typeof GetPriceTableData !== "function") {
      setPriceData([]);
      return;
    }
    try {
      const data = await GetPriceTableData(String(productId), normalizedProductCode);
      setPriceData(Array.isArray(data) ? data : []);
    } catch (error) {
      setPriceData([]);
    }
  };
  const ProDetailsList = (code) => {
    setdataempty(false);
    setPriceData([]);
    showLoader();
    //fetchStockStatus(code);
    var params = {
      productCode: code,
      userId: userId,
    };
    axiosInstance
      .post("Ebook/SearchProductDetails", params)
      .then((response) => {
        var res = response.data;
        //if (res && res.data) globalcontext.setCartItem(res.data);
        setAddtoCardDisplay("block");
        // if (res.Details == "Session Expier") {
        //   history(PAGES.LOGIN);
        // } else {
        if (res?.PrdId) {
          fetchStockStatus(res.PrdId);
          fetchPriceData(res.PrdId, code);
        } else {
          setPriceData([]);
        }
        setSearchResult(res);
        //}
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
      });
  };

  return (
    <div className="quickOrder-panel">
      <h3 className="quickOrder-title">Product Entry</h3>

      <div className="quickcart-search">
        <div className="quickOrder-container">
          {/*<div className="quickOrder-suggestions" style={{ display: "none" }}>*/}
          {/*    <div>ST003 - It is a long established <span className="quickOrderHighlight">f</span>act that a reader</div>*/}
          {/*    <div>ST004 - Contrary to popular belie<span className="quickOrderHighlight">f</span></div>*/}
          {/*    <div>ST005 - There are many variations o<span className="quickOrderHighlight">f</span> passages&nbsp;</div>*/}
          {/*    <div>ST006 - The standard chunk o<span className="quickOrderHighlight">f</span> Lorem Ipsum</div>*/}
          {/*    <div>STC026 - <span className="quickOrderHighlight">F</span>inibus Bonorum et Malorum</div>*/}
          {/*</div>*/}
          <input
            ref={codeInputRef}
            type="text"
            onChange={(e) => {
              handleOnType(e);
              setdataempty(false);
            }}
            value={productCode}
            autoComplete="off"
            data-required="true"
            className="form-control border border-1 py-1"
            id="quickOrderSearch"
            name="textbox"
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
            onKeyDown={autosuggestionKeyPress}
            placeholder="Enter Order Code"
          />
          {showSuggestions && isValidArray(suggestion) && (
            <ul ref={suggestionListRef} className="autosuggest-suggestions">
              {suggestion.map((item, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setProductCode(item.code);
                    ProDetailsList(item.code);
                  }}
                  className={index == activeSuggestion ? "active" : ""}
                >
                  {item.code}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="button-effect quickcart-effect">
          <button type="button" className="btn theme-primary" onClick={() => ProDetailsList(productCode)}>
            Search
          </button>
        </div>
      </div>

      {searchItem != null && searchItem.OrderCode != "" ? (
        <div className="quickOrder-productContainer mt-3" style={{ display: addSuccess ? "none" : "block" }}>
          <div className="quickOrder-product">
            <div className="cart-added-products quickOrderAdd">
              <div className="added-cartPro-img">
                <ImageWithDefault src={searchItem.ImagePath} alt="Product-image" />
              </div>
              <div className="added-cartPro-content">
                <div className="added-cartPro-info">
                  <div className="added-cartPro-item">
                    <h6>
                      <a href={searchItem.productUrlPath}>{searchItem.FamilyName}</a>
                    </h6>
                    {eBayBlock && searchItem.ebyBlock ? (
                      <div>
                        <p className="text-danger">This product is not available for purchase.</p>
                      </div>
                    ) : (
                      <div className="rowProduct-btns quickOrder-addCart" style={{ display: addtoCardDisplay }}>
                        <div className="product-quantity" key={searchItem.PrdId}>
                          <div className={"qty-container "}>
                            <button className="custom-btn-minus btn-light" type="button" onClick={QuantityDec}>
                              <i className="fa fa-minus" />
                            </button>
                            <input
                              type="text"
                              name="qty"
                              value={qty}
                              ref={quantityInputRef}
                              className="input-qty"
                              onChange={handleOnChange}
                            />
                            <button className="custom-btn-plus btn-light" type="button" onClick={QuantityInc}>
                              <i className="fa fa-plus" />
                            </button>
                          </div>
                        </div>

                        <div className="product-button button-effect">
                          <button
                            type="submit"
                            className="btn btn-products btn-addcart addToCart"
                            id="orderToastBtn"
                            onClick={AddItemCart}
                            style={{ display: addtoCardDisplay }}
                          >
                            <span className="wes-cart"></span>Add to Cart
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="quickOrder-availability">
                      <p>
                        Code:<span>{searchItem.OrderCode}</span>
                      </p>
                      <p>
                        Availability:{" "}
                        {eBayBlock && searchItem.ebyBlock ? (
                          "UNAVAILABLE"
                        ) : (
                          <span
                            className="stock-status"
                            dangerouslySetInnerHTML={{ __html: productStockStatus?.stockStatus ?? "" }}
                          />
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricingDetails-dropdown pricingDetails-dropdown-order mt-2 mt-sm-3">
              <div className="pricingDetails-header">
                <div className="cost-ex">Cost Ex</div>
                <div className="cost-ex">Qty</div>
              </div>
              {/* {searchItem.details}*/}
              <div className="pricingDetails-content">
                {priceData.map((item, index) => (
                  <div className="pricingDetails-content-list" key={index}>
                    <div className="price-ex">{Number(item.price2).toFixed(2)}</div>
                    <div className="price-ex">{item.qty}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="quickOrder-productContainer mt-3"
          style={{ display: dataempty ? "block" : "none", background: "none", color: "red" }}
        >
          No product found. Please check the product code and try again.
        </div>
      )}
      {searchItemSubstuitu != null ? (
        <div className="quickOrder-productContainer mt-3">
          <div id="divSubProduct" className="product_description">
            <div style={{ borderTop: "none" }}>
              <div className="subproduct_head">
                <ImageWithDefault
                  src="https://www.wes.com.au/images/subproduct_icon.jpg"
                  alt="Substitute Product"
                  width="28"
                  height="28"
                />
                <h4>SUBSTITUTED PRODUCT ITEM</h4>
              </div>
              <div className="subproduct_details">
                <p>
                  <span>NOTICE!</span>This product is currently unavailable and has been replaced with the product
                  below:
                </p>
                <span>
                  <a href={searchItemSubstuitu.redirectUrl} id="TBT_REP_NIL_CODE">
                    {" "}
                    {searchItemSubstuitu.substituteCode}
                  </a>
                </span>
                <a
                  href={searchItemSubstuitu.redirectUrl}
                  id="a_ViewSubPro"
                  className="toplinkatest"
                  style={{ cursor: "pointer", fontSize: "12px" }}
                >
                  View Substitute Product
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div
        id="orderToast"
        className="toast hide mt-3"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ display: addSuccess ? "block" : "none" }}
      >
        <div className="toast-body">
          <div className="addedOrderLft">
            <i className="fa-solid fa-circle-check"></i>
          </div>
          <div className="addedOrderRft">
            <h5>{productCode} Successfully added to cart</h5>
            <p>Please enter next product code above.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
